module.exports = __webpack_public_path__ + "img/Home21-Teacher.5a2196fe.jpg";